<template>
  <el-dialog :title="$t('platformCoupon.editCoupon')" :visible.sync="dialogVisible" width="70%"
    @close="handleClose">
    <el-form ref="form" :model="editCouponInfo" label-width="120px">
      <el-form-item :label="$t('platformCoupon.couponCode')">
        <el-input v-model="editCouponInfo.couponCode" disabled />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.couponName')"
        :rules="[{ required: true, message: $t('platformCoupon.couponNameRequired'), trigger: 'blur' }]">
        <el-input v-model="editCouponInfo.couponName"
          :placeholder="$t('platformCoupon.couponNameRequired')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.couponType')">
        <el-select v-model="editCouponInfo.couponType" :placeholder="$t('platformCoupon.couponTypeRequired')"
          style="width:100%" @change="_changeCouponType">
          <el-option :label="$t('platformCoupon.fullReduction')" value="01" />
          <el-option :label="$t('platformCoupon.discount')" value="02" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="editCouponInfo.couponType === '01'" :label="$t('platformCoupon.discountAmount')"
        :rules="[{ required: true, message: $t('platformCoupon.discountAmountRequired'), trigger: 'blur' }]">
        <el-input v-model="editCouponInfo.discountAmount" type="number"
          :placeholder="$t('platformCoupon.discountAmountRequired')" />
      </el-form-item>

      <el-form-item v-if="editCouponInfo.couponType === '02'" :label="$t('platformCoupon.discountPercent')"
        :rules="[{ required: true, message: $t('platformCoupon.discountPercentRequired'), trigger: 'blur' }]">
        <el-input v-model="editCouponInfo.discountPercent" type="number"
          :placeholder="$t('platformCoupon.discountPercentRequired')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.minAmount')">
        <el-input v-model="editCouponInfo.minAmount" type="number"
          :placeholder="$t('platformCoupon.minAmountPlaceholder')" />
      </el-form-item>

      <el-form-item v-if="editCouponInfo.couponType === '02'" :label="$t('platformCoupon.maxDiscount')">
        <el-input v-model="editCouponInfo.maxDiscount" type="number"
          :placeholder="$t('platformCoupon.maxDiscountPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.description')">
        <el-input v-model="editCouponInfo.description" type="textarea"
          :placeholder="$t('platformCoupon.descriptionPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.totalQuantity')"
        :rules="[{ required: true, message: $t('platformCoupon.totalQuantityRequired'), trigger: 'blur' }]">
        <el-input v-model="editCouponInfo.totalQuantity" type="number"
          :placeholder="$t('platformCoupon.totalQuantityRequired')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.limitPerUser')">
        <el-input v-model="editCouponInfo.limitPerUser" type="number"
          :placeholder="$t('platformCoupon.limitPerUserPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.validDays')">
        <el-input v-model="editCouponInfo.validDays" type="number"
          :placeholder="$t('platformCoupon.validDaysPlaceholder')" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.startTime')">
        <el-date-picker v-model="editCouponInfo.startTime" type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('platformCoupon.startTimePlaceholder')" style="width:100%" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.endTime')">
        <el-date-picker v-model="editCouponInfo.endTime" type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :placeholder="$t('platformCoupon.endTimePlaceholder')" style="width:100%" />
      </el-form-item>

      <el-form-item :label="$t('platformCoupon.status')">
        <el-select v-model="editCouponInfo.statusCd" :placeholder="$t('platformCoupon.selectStatus')"
          style="width:100%">
          <el-option :label="$t('platformCoupon.inUse')" value="0" />
          <el-option :label="$t('platformCoupon.invalid')" value="1" />
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="updateCouponInfo">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updatePlatformCoupon } from '@/api/coupon/couponApi'

export default {
  name: 'EditPlatformCoupon',
  data() {
    return {
      dialogVisible: false,
      editCouponInfo: {}
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      // 平台券无店铺维度，回显时剔除 shopId；发放方式固定为用户领取不回显
      const couponInfo = { ...row }
      delete couponInfo.shopId
      couponInfo.issueType = '01'
      this.editCouponInfo = couponInfo
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.editCouponInfo = {}
    },
    _changeCouponType() {
      // 切换优惠类型时清空相关字段
      if (this.editCouponInfo.couponType === '01') {
        this.editCouponInfo.discountPercent = ''
        this.editCouponInfo.maxDiscount = ''
      } else {
        this.editCouponInfo.discountAmount = ''
      }
    },
    async updateCouponInfo() {
      try {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            await updatePlatformCoupon(this.editCouponInfo)
            this.$message.success(this.$t('common.saveSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          }
        })
      } catch (error) {
        this.$message.error(error)
        console.error(error)
      }
    }
  }
}
</script>
